import { ToolkitPageLayout } from 'toolkit/components/ToolkitPageLayout'
import { Link } from 'react-router-dom'

// TODO: Host the video asset and update this URL
const establishing_scd_clinic_video_url =
  'https://www.dropbox.com/scl/fi/8fo2x2gpelx2sif77d1pb/zoom_2-2.mp4?rlkey=5mbx29vsf7l6exn3ag0j0mjui&dl=0&dl=1'

// URL for the Lanzkron et al., 2015 paper PDF
const lanzkronPaperPdfUrl =
  'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4409504/pdf/nihms660871.pdf'
const lanzkronPaperTitle =
  'Impact of a Dedicated Infusion Center for Acute Management of Adults in Sickle Cell Pain Crisis by Lanzkron et al., 2015'

export const InstitutionEstablishingScdClinicPage: React.FC = () => {
  const breadcrumbs = [
    { label: 'Toolkit', path: '/toolkit' },
    { label: 'Institution', path: '/toolkit/institution' },
    {
      label: 'Resources for Building an IC',
      path: '/toolkit/institution/building-ic-resources'
    },
    {
      label: 'Establishing an SCD Clinic',
      path: '/toolkit/institution/establishing-scd-clinic'
    }
  ]

  return (
    <ToolkitPageLayout
      title="Establishing a Sickle Cell Disease Clinic"
      breadcrumbs={breadcrumbs}
    >
      <div className="prose max-w-none mx-auto px-4 py-8">
        {/* Lanzkron Paper PDF Section - PDF First */}
        <div className="mb-10 p-6 bg-white rounded-lg shadow-lg border border-gray-200">
          <object
            data={lanzkronPaperPdfUrl}
            type="application/pdf"
            width="100%"
            height="600px"
            className="rounded shadow border mb-4"
          >
            <p className="text-center text-gray-600 p-4">
              PDF preview not available. Please use the links below to view or
              download.
            </p>
          </object>
          <h3 className="text-xl font-semibold text-[#142841] mb-2">
            {lanzkronPaperTitle}
          </h3>
          <p className="text-sm text-gray-700 mb-4">
            This key research paper discusses the impact and benefits of
            dedicated infusion centers for managing acute sickle cell pain
            crises.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 items-center">
            <a
              href={lanzkronPaperPdfUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#A6410A] text-white px-6 py-2 rounded-md hover:bg-[#C25F0C] transition-colors text-center text-sm font-medium"
            >
              View Full Paper (External PDF)
            </a>
            <a
              href={lanzkronPaperPdfUrl}
              download="Lanzkron_et_al_2015_Impact_of_Dedicated_Infusion_Center.pdf"
              className="text-[#142841] hover:text-[#A6410A] underline transition-colors text-center text-sm font-medium"
            >
              Download PDF
            </a>
          </div>
        </div>

        <hr className="my-12" />

        {/* Video Section */}
        <h3 className="text-xl font-semibold text-[#142841] mb-3 mt-10">
          Video: Establishing a Sickle Cell Disease Clinic
        </h3>
        <figure className="mb-12">
          <div className="aspect-w-16 aspect-h-9 max-w-3xl mx-auto bg-black rounded-lg shadow-lg overflow-hidden">
            <video
              controls
              src={establishing_scd_clinic_video_url}
              className="w-full h-full"
            >
              Your browser does not support the video tag.
            </video>
          </div>
          <figcaption className="text-center mt-3 text-md font-medium text-gray-700">
            <strong>
              Establishing a Sickle Cell Disease Clinic by Mandy David MPH, PA-C
            </strong>
          </figcaption>
        </figure>

        <div className="mt-12 text-center">
          <Link
            to="/toolkit/institution/building-ic-resources"
            className="inline-block bg-[#A6410A] text-white font-semibold px-8 py-3 rounded-lg shadow-md hover:bg-[#C25F0C] transition-colors duration-300"
          >
            All done? Back to Resources for Building an IC
          </Link>
        </div>
      </div>
    </ToolkitPageLayout>
  )
}
